import {
    getCountriesDataView,
    getCurrentCountries,
} from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import convertSelectorToHook from "@toolkit/Framework/Common/Utilities/convertSelectorToHook";

export const useCurrentCountries = convertSelectorToHook(getCurrentCountries);
export const useCountriesDataView = convertSelectorToHook(getCountriesDataView);
